export default __webpack_public_path__ + "static/media/ColorShiftsInprogress.a2470d30.svg";